require("slick-carousel");

$(() => {
  let slider = $(".box-slider");
  let sliderAssure = $("#assure .box-step");

  let modalCalcuate = $("#modal-calculate");
  let quantity = modalCalcuate.find("#quantity");
  let price = modalCalcuate.find("#price");
  let btnCalculate = modalCalcuate.find("#btn_calculate");

  let media600 = window.matchMedia("(max-width: 601px)");

  slider.slick({
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 801,
        settings: {
          arrows: false
        }
      }
    ]
  });

  if (media600.matches) {
    sliderAssure.slick({
      arrows: false,
      dots: true
    });
  }

  btnCalculate.on("click", e => {
    e.preventDefault();
    let value = quantity.val();
    let amount;

    switch (value) {
      case "1":
        amount = value * 34.9;
        break;

      case "2":
        amount = value * 32.9;
        break;

      default:
        amount = value * 29.9;
    }

    price.text("S/ " + amount);
  });

  const formContact = async e => {
    e.preventDefault();

    const el = $(e.currentTarget);
    const action = el.attr("action");
    const isValid = el.valid();

    if (isValid) {
      try {
        const response = await fetch(action, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            name: el.find("input[name=name]").val(),
            phone: el.find("input[name=phone]").val(),
            email: el.find("input[name=email]").val(),
            quantity: el.find("input[name=quantity]").val()
          })
        });

        const data = await response.json();

        if (data.success) {
          el.hide();
          $("#form-thanks").fadeIn();
        }
      } catch (error) {
        console.error("error: ", error);
      }
    }
  };

  $("#form-contact").on("submit", formContact);
});
